import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { MonthlyReport } from '../types/domain';

export function reportEndpoints(http: HttpClient) {
  return {
    monthly: (year?: number, month?: number) =>
      http.get<ApiEnvelope<MonthlyReport>>('/v1/reports/monthly', { query: { year, month } }).then(unwrap),
  };
}
export type ReportEndpoints = ReturnType<typeof reportEndpoints>;
